/*
********************************************************************************
- Archivo : client/src/components/User/IsValidatedUser/index.js
- Proyecto: CB30
- Propósito: Verificar si el usuario validado ha completado sus datos personales.
********************************************************************************
*/

import React from "react";
import Jumbotron from "./Jumbotron";

const IsValidatedUser = props => {

  const documento =
    props.userPerson &&
    props.userPerson.documento_de_identidad;

  if (documento) {
    return null;
  }

  return <Jumbotron />;
};

export default IsValidatedUser;


// WEBPACK FOOTER //
// ./src/components/User/IsValidatedUser/index.js